import React from 'react';
import {
  TextCustom,
} from '../styles';
import {
  TaskDetails,
  ContainerDetails,
  Question,
} from './styles';

const SectionTaskDetails = ({ questions }) => {
  const Questions = ({ questionsParam }) => (
    <ContainerDetails>
      {
        questionsParam && questionsParam.map(question => (question.service_field_name && (
          <Question key={question.service_field_name}>
            <TextCustom size="14px" bold margin="0 0 5px 0">{question.service_field_name}</TextCustom>
            <TextCustom size="12px">{question.service_field_option_name || question.value}</TextCustom>
          </Question>
        )))
      }
    </ContainerDetails>
  );

  return (
    <TaskDetails>
      <TextCustom size="18px" bold color="#F07E31">Descrição do pedido:</TextCustom>
      <Questions questionsParam={questions} />
    </TaskDetails>
  );
};

export default SectionTaskDetails;
